import script from "./nameChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./nameChangeModal.vue?vue&type=script&setup=true&lang=js"

import "./nameChangeModal.vue?vue&type=style&index=0&id=19fa4cb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fa4cb5"]])

export default __exports__